// extracted by mini-css-extract-plugin
module.exports = {"secondary":"styles_secondary__XNSX2","fixed":"styles_fixed__QLvdE"};